export default __webpack_public_path__ + "static/assets/med_x_ointment.1c8741d2.png";